/**
 * rfa-design-center.js
 * Scoped entirely within .rfa-design-center
 * Safe to delete to fully revert. No global side effects.
 */
(function () {
  'use strict';

  const ROOT_SELECTOR = '.rfa-design-center';

  function init() {
    const root = document.querySelector(ROOT_SELECTOR);
    if (!root) return;

    initAccordion(root);
    initOptionCards(root);
    initSwatches(root);
    initDropzone(root);
    initReveal(root);
    initScrollCta(root);
    initAiGenerator(root);
  }

  /* ── Accordion FAQ ──────────────────────────────────────── */
  function initAccordion(root) {
    root.querySelectorAll('.rfa-accordion__trigger').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.rfa-accordion__item');
        var isOpen = item.classList.contains('is-open');

        // Close all
        root.querySelectorAll('.rfa-accordion__item').forEach(function (el) {
          el.classList.remove('is-open');
          el.querySelector('.rfa-accordion__panel').style.maxHeight = '';
        });

        // Open clicked if it was closed
        if (!isOpen) {
          item.classList.add('is-open');
          var panel = item.querySelector('.rfa-accordion__panel');
          var body = item.querySelector('.rfa-accordion__body');
          panel.style.maxHeight = body.scrollHeight + 32 + 'px';
        }
      });
    });
  }

  /* ── Option card selection ──────────────────────────────── */
  function initOptionCards(root) {
    root.querySelectorAll('.rfa-option-group').forEach(function (group) {
      group.querySelectorAll('.rfa-option-card').forEach(function (card) {
        card.addEventListener('click', function () {
          group.querySelectorAll('.rfa-option-card').forEach(function (c) {
            c.classList.remove('is-active');
          });
          card.classList.add('is-active');

          // update hidden field if present
          var field = group.querySelector('.rfa-option-value');
          if (field) field.value = card.dataset.value || '';
        });
      });
    });
  }

  /* ── Color swatches ─────────────────────────────────────── */
  function initSwatches(root) {
    root.querySelectorAll('.rfa-swatch').forEach(function (swatch) {
      swatch.addEventListener('click', function () {
        var siblings = swatch.closest('.rfa-color-swatches').querySelectorAll('.rfa-swatch');
        siblings.forEach(function (s) { s.classList.remove('is-active'); });
        swatch.classList.add('is-active');
      });
    });
  }

  /* ── Dropzone ───────────────────────────────────────────── */
  function initDropzone(root) {
    var zone = root.querySelector('.rfa-dropzone');
    if (!zone) return;
    var input = zone.querySelector('.rfa-dropzone__input');
    var preview = zone.querySelector('.rfa-dropzone__preview');

    zone.addEventListener('click', function () { input && input.click(); });

    zone.addEventListener('dragover', function (e) {
      e.preventDefault();
      zone.classList.add('is-over');
    });
    zone.addEventListener('dragleave', function () { zone.classList.remove('is-over'); });
    zone.addEventListener('drop', function (e) {
      e.preventDefault();
      zone.classList.remove('is-over');
      if (e.dataTransfer && e.dataTransfer.files) handleFiles(e.dataTransfer.files);
    });

    if (input) {
      input.addEventListener('change', function () { handleFiles(input.files); });
    }

    function handleFiles(files) {
      if (!preview) return;
      Array.from(files).slice(0, 5).forEach(function (file) {
        if (!file.type.startsWith('image/')) return;
        var reader = new FileReader();
        reader.onload = function (e) {
          var img = document.createElement('img');
          img.src = e.target.result;
          img.className = 'rfa-dropzone__thumb';
          img.alt = 'Inspiration image';
          preview.appendChild(img);
        };
        reader.readAsDataURL(file);
      });
    }
  }

  /* ── Scroll reveal (IntersectionObserver) ───────────────── */
  function initReveal(root) {
    if (!window.IntersectionObserver) {
      root.querySelectorAll('[data-rfa-reveal]').forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var delay = entry.target.dataset.rfaDelay || 0;
          setTimeout(function () {
            entry.target.classList.add('is-visible');
          }, parseInt(delay, 10));
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });

    root.querySelectorAll('[data-rfa-reveal]').forEach(function (el) {
      io.observe(el);
    });
  }

  /* ── Scroll CTA anchor ──────────────────────────────────── */
  function initScrollCta(root) {
    root.querySelectorAll('[data-rfa-scroll]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        var target = root.querySelector(btn.dataset.rfaScroll);
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  }

  /* ── AI Jersey Generator ────────────────────────────────── */
  function initAiGenerator(root) {
    var WORKER_URL = 'https://rfa-jersey-generato.summer-hat-0f3a.workers.dev';

    var chips     = root.querySelectorAll('.rfa-ai-chip');
    var textarea  = root.querySelector('#rfa-ai-prompt');
    var charCount = root.querySelector('#rfa-ai-chars');
    var genBtn    = root.querySelector('#rfa-ai-generate');
    var regenBtn  = root.querySelector('#rfa-ai-regenerate');
    var retryBtn  = root.querySelector('#rfa-ai-retry');

    var placeholder = root.querySelector('#rfa-ai-placeholder');
    var loading     = root.querySelector('#rfa-ai-loading');
    var imageWrap   = root.querySelector('#rfa-ai-image-wrap');
    var imageEl     = root.querySelector('#rfa-ai-image');
    var downloadEl  = root.querySelector('#rfa-ai-download');
    var errorEl     = root.querySelector('#rfa-ai-error');

    if (!genBtn) return;

    // Chip selection
    chips.forEach(function(chip) {
      chip.addEventListener('click', function() {
        chips.forEach(function(c) { c.classList.remove('is-active'); });
        chip.classList.add('is-active');
        textarea.value = chip.dataset.prompt || '';
        updateCharCount();
      });
    });

    // Character counter
    function updateCharCount() {
      if (charCount) charCount.textContent = (textarea.value || '').length;
    }
    if (textarea) textarea.addEventListener('input', updateCharCount);

    // Show/hide states
    function showState(state) {
      placeholder.style.display = state === 'placeholder' ? 'block' : 'none';
      loading.style.display     = state === 'loading'     ? 'block' : 'none';
      imageWrap.style.display   = state === 'image'       ? 'block' : 'none';
      errorEl.style.display     = state === 'error'       ? 'block' : 'none';
    }

    // Generate
    async function generate() {
      var prompt = textarea ? textarea.value.trim() : '';
      if (!prompt || prompt.length < 5) {
        textarea.focus();
        return;
      }

      genBtn.disabled = true;
      genBtn.textContent = '✨ Generating…';
      showState('loading');

      try {
        var res = await fetch(WORKER_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ prompt: prompt })
        });

        if (!res.ok) throw new Error('Worker error ' + res.status);

        var data = await res.json();

        if (data.imageUrl) {
          imageEl.src = data.imageUrl;
          downloadEl.href = data.imageUrl;
          imageEl.onload = function() { showState('image'); };
          imageEl.onerror = function() { showState('error'); };
        } else {
          showState('error');
        }

      } catch(err) {
        console.error('RFA AI Generator error:', err);
        showState('error');
      }

      genBtn.disabled = false;
      genBtn.textContent = '✨ Generate My Jersey Concept';
    }

    genBtn.addEventListener('click', generate);
    if (regenBtn) regenBtn.addEventListener('click', generate);
    if (retryBtn) retryBtn.addEventListener('click', generate);
  }


  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
